<template>
    <div :content="lastUpdateDate"  v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
        <span :class="{ 'status-alert': isError }">{{ statusText }}</span>
    </div>
</template>

<script>
// Stany bez błędu: Operational z API, a Alarms Off i No Monitoring ustawia Systems.vue
// (No Monitoring to system, który jeszcze nie raportował — brak danych, nie błąd).
// Wszystko inne (System down, lista opisów błędów) wyróżniamy.
const OK_STATUSES = ['Operational', 'Alarms Off', 'No Monitoring']

export default {
    data() {
        return {
            data: {},
        }
    },
    computed: {
        statusText() {
            return this.data.systemStatus.split(',').map(x => this.$t(x.trim())).join(', ')
        },
        isError() {
            var status = (this.data.systemStatus || '').trim()
            return status !== '' && !OK_STATUSES.includes(status)
        },
        lastUpdateDate() {
            var dt = this.data.lastUpdate

            if(dt == '0001-01-01T00:00:00'){
                return this.$t('No Monitoring')
            }

            var result = new Date(this.data.lastUpdate).toAgoString()
            result += `<br\>${ this.$t('CPUTemperature') }: ${this.data.temperature}°C<br\>${ this.$t('FreeSpace') }: ${this.data.freeSpaceGb}GB<br\>${ this.$t('Restart') }: ${new Date(this.data.lastRestart).toAgoStringVer2()}`

            if ((this.data.alarmsOffCrfi != undefined && this.data.alarmsOffCrfi != '0001-01-01T00:00:00')
                || (this.data.alarmsOffMonitoring != undefined && this.data.alarmsOffMonitoring != '0001-01-01T00:00:00')) {
                  var alarmsOffCrfi = this.data.alarmsOffCrfi != '0001-01-01T00:00:00' ? this.$t('Off') : this.$t('On');
                  var alarmsOffMonitoring = this.data.alarmsOffMonitoring != '0001-01-01T00:00:00' ? this.$t('Off') : this.$t('On');
                  var from = null;

                  if (alarmsOffCrfi == this.$t('Off')) {
                    if (alarmsOffMonitoring == this.$t('Off')) {
                      from = new Date(this.data.alarmsOffCrfi) < new Date(this.data.alarmsOffMonitoring) ? new Date(this.data.alarmsOffCrfi) : new Date(this.data.alarmsOffMonitoring);
                    }
                    else {
                      from = new Date(this.data.alarmsOffCrfi);
                    }
                  } else {
                    from = new Date(this.data.alarmsOffMonitoring);
                  }

                  result = `${ this.$t('AlarmsCRFI') }: ${ alarmsOffCrfi }`;
                  result += `<br\>${ this.$t('AlarmsMonitoring') }: ${ alarmsOffMonitoring }`;
                  result += `<br\>${this.$t('From')}: ${from.toISOString().split('T')[0]}`;
                }
            return result
        }
    }
}
</script>

<style scoped>
/* Kolory z tokenów --status-alert-* (assets/css/theme.css), osobno dla motywu jasnego i ciemnego.
   Ujemny margin wypycha tło poza tekst, żeby wyróżnienie nie zabierało szerokości
   wąskiej kolumny. Komórki tabeli łamią tekst w dowolnym miejscu — tu wracamy do
   łamania na spacjach, a słowo dzielimy tylko, gdy samo nie mieści się w linii. */
.status-alert {
    display: block;
    margin: -2px -6px;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: var(--status-alert-bg);
    color: var(--status-alert-fg);
    font-weight: 600;
    word-break: normal;
    overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/StatusWithLastUpdateTooltip.vue